export default __webpack_public_path__ + "static/media/advisor-dm.31c53c6b.jpg";